module.exports = __webpack_public_path__ + "static/Homepage-voter.06750aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Homepage-voter.png
// module id = 498
// module chunks = 265584890008614